// @flow

import React from "react";

import * as colors from "src/styles/constants/colors";

type Props = {
  size?: number,
  isDisabled?: boolean
};

const ActivePicklistCheckbox = ({ size = 24, isDisabled = false }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}px`}
    viewBox="0 0 24 24"
    width={`${size}px`}
    fill={isDisabled ? colors.grey35 : colors.blue500}
  >
    <rect
      x="0"
      y="0"
      width="24"
      height="24"
      rx="3"
      fill={isDisabled ? colors.grey35 : colors.blue500}
    />
    <rect
      x="1"
      y="1"
      width="22"
      height="22"
      rx="3"
      fill="none"
      stroke={isDisabled ? colors.grey35 : colors.blue500}
      strokeWidth="2"
    />
    <path
      d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
      fill={isDisabled ? colors.grey44 : colors.brightLight}
      stroke={isDisabled ? colors.grey44 : colors.brightLight}
      strokeWidth="1"
    />
  </svg>
);

export default ActivePicklistCheckbox;
